import * as React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import { ApiRequest } from 'GlobalFunctions';
import { LinearProgress } from '@mui/material';

export default function AutocompleteField(props: any){

  const {
    endpoint = "",
    endpoint_params = {},
    preloadedList,
    label,
    value,
    onChange,
    renderValues = ["label"],
    multiple = false,
    readOnly = false,
    disabled = false,
  } = props;

  const uniqueId = React.useId();

  const [list, setList] = useState<any>([]);
  const [selectedItems, setSelectedItems] = useState<any>(multiple ? [] : null);

  useEffect(() => {
    if (preloadedList) {
      setList(preloadedList);
    } else {
      getList();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preloadedList, JSON.stringify(endpoint_params)]);

  const getList = async () => {
    await ApiRequest({
      url: endpoint,
      method: "get",
      query: {
          full_list: true,
          ...endpoint_params
      }, 
      setResponse: (response: any) => {
          setList(response.list);
      },
    });
  }

  useEffect(() => {
    if (!multiple) {
      if (list && (value && value !== 0)) {
        let item = list.find((obj: any) => obj.value === parseInt(value));
        if (item) {
          console.log("item", item);
          setSelectedItems(item);
        }
      }
    } else {
      if (list && value && Array.isArray(value)) {
        let items = list.filter((obj: any) => value.includes(obj.value));
        setSelectedItems(items);
      }
    }
  }, [list, value, multiple]);

  return (
    <>
      {list && list.length > 0 ? (
        <Autocomplete
          value={selectedItems}
          onChange={(event: any, newValue: any) => {
            if (!multiple) {
              // Aquí comprobamos si se eliminó el valor (newValue será null)
              setSelectedItems(newValue);  // Actualiza el estado de selectedItems
              onChange(newValue ? newValue : null);  // Pasa null si se elimina el valor
            }
            else {
              setSelectedItems(newValue);
              onChange(newValue ? newValue.map((item: any) => item.value) : []); // Pasa un array vacío si se elimina el valor
            }
          }}
          
          multiple={multiple}
          id={uniqueId}
          options={list}
          fullWidth
          disabled={disabled}
          readOnly={readOnly}
          getOptionLabel={(option: any) => `${option[renderValues[0]]}`}
          renderOption={(props: any, option: any) => (
            <li className="flex_select" {...props} key={option.value} style={{  display: "flex",flexDirection: "column", alignItems: "flex-start"}}>
              {renderValues.map((renderValue: any, index: any) => (
                <span key={index} className="flex_select_item" style={{ fontWeight: index === 0 ? "bold" : "normal", fontSize:12 }}>
                  {option[renderValue]}
                  {index < renderValues.length - 1 }
                </span>
              ))}
            </li>
          )}
          renderInput={(params) => {
            const inputText = (params as any).inputProps?.value || '';
            const hasValue = inputText.length > 0 || (Array.isArray(selectedItems)
              ? selectedItems.length > 0
              : selectedItems !== null && selectedItems !== undefined);
            return (
              <TextField
                {...params}
                label={label}
                variant="outlined"
                InputLabelProps={{
                  ...params.InputLabelProps,
                  shrink: false,
                  style: { display: hasValue ? 'none' : undefined },
                }}
                sx={{
                  backgroundColor: 'white',
                  borderRadius: "5px",
                  '& .MuiOutlinedInput-notchedOutline': { top: 0 },
                  '& legend': { display: 'none' },
                  '& .MuiChip-root': {
                    '& .MuiChip-label': { fontSize: '12px' },
                  },
                }}
              />
            );
          }}
        />
      ) : (
        <>
          <LinearProgress />
        </>
      )}
    </>
  );
}
